import { SecureApiService } from '../secureApiService';
import { FlightService, IFlightService } from './flightService';
import { flightChangeCaseMapper } from './mappers';
import { flightErrorHandler } from './errors';
import { API_CONFIG } from './constants';

export class FlightServiceFactory {
    static create(apiService: SecureApiService): IFlightService {
        return new FlightService(
            apiService,
            flightChangeCaseMapper,
            flightErrorHandler,
            API_CONFIG.BASE_URL
        );
    }
}

export const createFlightService = (apiService: SecureApiService): FlightService => {
    return FlightServiceFactory.create(apiService) as FlightService;
};

